/* review-carousel.js - robust carousel + like behavior (keeps clones in sync)
   - recalcula ancho con offsetWidth y recalc al pointerdown para evitar cortes en móvil
   - like persiste en localStorage y actualiza clones
*/

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.rc-wrapper[data-section-id]').forEach(initSection);
});

function initSection(wrapper) {
  if (wrapper.dataset.rcInit === '1') return;
  wrapper.dataset.rcInit = '1';

  const sectionId = wrapper.getAttribute('data-section-id') || 'rc_default';
  const track = wrapper.querySelector('.rc-track');
  if (!track) return;
  const prevBtn = wrapper.querySelector('.rc-prev');
  const nextBtn = wrapper.querySelector('.rc-next');
  const dotsWrap = wrapper.querySelector('.rc-dots');

  // initial originals
  let origChildren = Array.from(track.children);
  const origCount = origChildren.length || 1;

  // clone once for infinite effect
  if (track.dataset.cloned !== '1') {
    track.dataset.origCount = String(origCount);
    const fragStart = document.createDocumentFragment();
    const fragEnd = document.createDocumentFragment();
    origChildren.forEach(node => {
      fragEnd.appendChild(node.cloneNode(true));
      fragStart.appendChild(node.cloneNode(true));
    });
    track.appendChild(fragEnd);
    track.insertBefore(fragStart, track.firstChild);
    track.dataset.cloned = '1';
  }

  // recalc cards
  let allCards = Array.from(track.children);

  function getCardWidth() {
    allCards = Array.from(track.children);
    const first = allCards[0];
    if (!first) return 0;
    const style = getComputedStyle(track);
    const gap = parseFloat(style.gap || style.columnGap || 18) || 18;
    const w = first.offsetWidth;
    return Math.round(w + gap);
  }

  let visibleCardWidth = getCardWidth();
  let index = origCount;

  // dots
  function createDots() {
    dotsWrap.innerHTML = '';
    for (let i = 0; i < origCount; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rc-dot';
      btn.dataset.i = String(i);
      btn.setAttribute('aria-label', `Ir a reseña ${i + 1}`);
      if (i === 0) btn.classList.add('active');
      dotsWrap.appendChild(btn);
    }
  }
  createDots();

  function updateDots() {
    const active = ((index - origCount) % origCount + origCount) % origCount;
    Array.from(dotsWrap.children || []).forEach((d, i) => d.classList.toggle('active', i === active));
  }

  function setPosition(animate = true) {
    if (!animate) track.style.transition = 'none';
    else track.style.transition = 'transform .36s cubic-bezier(.22,.9,.36,1)';
    const x = -(index * visibleCardWidth);
    track.style.transform = `translateX(${x}px)`;
    if (!animate) { track.getBoundingClientRect(); track.style.transition = 'transform .36s cubic-bezier(.22,.9,.36,1)'; }
    updateDots();
  }

  function moveNext() { index += 1; setPosition(true); }
  function movePrev() { index -= 1; setPosition(true); }

  prevBtn && prevBtn.addEventListener('click', movePrev);
  nextBtn && nextBtn.addEventListener('click', moveNext);

  track.addEventListener('transitionend', () => {
    if (index <= origCount - 1) { index = index + origCount; setPosition(false); }
    else if (index >= origCount * 2) { index = index - origCount; setPosition(false); }
  });

  // autoplay
  const autoplay = wrapper.getAttribute('data-autoplay') === 'true' || wrapper.getAttribute('data-autoplay') === '1';
  const speed = parseInt(wrapper.getAttribute('data-autoplay-speed') || '3200', 10) || 3200;
  let timer = null;
  function startAuto() { if (!autoplay) return; stopAuto(); timer = setInterval(moveNext, speed); }
  function stopAuto() { if (timer) clearInterval(timer); timer = null; }
  startAuto();
  wrapper.addEventListener('mouseenter', stopAuto); wrapper.addEventListener('mouseleave', startAuto);
  wrapper.addEventListener('focusin', stopAuto); wrapper.addEventListener('focusout', startAuto);

  // dots click
  dotsWrap.addEventListener('click', (e) => {
    const dot = e.target.closest('.rc-dot'); if (!dot) return;
    index = Number(dot.dataset.i) + origCount; setPosition(true);
  });

  // swipe: recalc width at pointerdown to avoid clipping on mobile
  let startX = 0, down = false;
  track.addEventListener('pointerdown', (e) => {
    down = true; startX = e.clientX;
    visibleCardWidth = getCardWidth();
    stopAuto();
    track.style.transition = 'none';
    try { e.target.setPointerCapture && e.target.setPointerCapture(e.pointerId); } catch (err) {}
  });
  window.addEventListener('pointermove', (e) => {
    if (!down) return;
    const dx = e.clientX - startX;
    track.style.transform = `translateX(${-(index * visibleCardWidth) + dx}px)`;
  });
  window.addEventListener('pointerup', (e) => {
    if (!down) return;
    down = false;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > visibleCardWidth / 4) { if (dx < 0) moveNext(); else movePrev(); } else setPosition(true);
    startAuto();
  });
  window.addEventListener('pointercancel', () => { if (!down) return; down = false; setPosition(true); startAuto(); });

  // recalc on resize (debounced)
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => { visibleCardWidth = getCardWidth(); setPosition(false); }, 120);
  });

  // wait images loaded then initial placement
  const imgs = wrapper.querySelectorAll('img');
  let pending = imgs.length;
  if (pending === 0) { visibleCardWidth = getCardWidth(); setPosition(false); }
  else {
    imgs.forEach(img => {
      if (img.complete) pending--;
      else {
        img.addEventListener('load', () => { pending--; if (pending === 0) { visibleCardWidth = getCardWidth(); setPosition(false); } }, { once: true });
        img.addEventListener('error', () => { pending--; if (pending === 0) { visibleCardWidth = getCardWidth(); setPosition(false); } }, { once: true });
      }
    });
  }

  // LIKE logic: gather originals (middle slice) and sync clones
  const all = Array.from(track.children);
  const midStart = origCount;
  const midEnd = origCount + origCount;
  const originalSlice = (all.length >= midEnd) ? all.slice(midStart, midEnd) : all.slice(0, origCount);
  const ids = originalSlice.map((n, i) => {
    let id = n.getAttribute('data-id');
    if (!id) { id = `rc_auto_${i}`; n.setAttribute('data-id', id); }
    return id;
  });

  function refresh(id) {
    const nodes = wrapper.querySelectorAll(`.rc-card[data-id="${id}"]`);
    if (!nodes.length) return;
    const base = Number(nodes[0].getAttribute('data-likes') || 0);
    const key = `rc_like_${sectionId}_${id}`;
    const liked = localStorage.getItem(key) === '1';
    const display = base + (liked ? 1 : 0);
    nodes.forEach(node => {
      const countEl = node.querySelector('.rc-like-count'); if (countEl) countEl.textContent = String(display);
      const btn = node.querySelector('.rc-like-btn'); if (btn) { btn.setAttribute('aria-pressed', liked ? 'true' : 'false'); btn.classList.toggle('liked', liked); }
    });
  }
  ids.forEach(id => refresh(id));

  wrapper.addEventListener('click', (e) => {
    const b = e.target.closest('.rc-like-btn'); if (!b) return;
    e.stopPropagation();
    const card = b.closest('.rc-card'); if (!card) return;
    const id = card.getAttribute('data-id'); if (!id) return;
    const key = `rc_like_${sectionId}_${id}`;
    const was = localStorage.getItem(key) === '1';
    if (was) localStorage.removeItem(key); else localStorage.setItem(key, '1');
    refresh(id);
    try { b.animate([{ transform: 'scale(1)' }, { transform: 'scale(.96)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }], { duration: 220, easing: 'ease-out' }); } catch (err) {}
  });
}